import { NavLink } from "react-router";
import { useTranslation } from "react-i18next";
import { useNavItems } from "./navItems";

/**
 * Primary navigation between the wedding's destinations. Renders as a fixed bar
 * pinned to the bottom of the viewport at every screen size: an inline row of
 * icon + label tabs on desktop, and stacked icon-over-label tabs that stretch
 * full width on mobile (one markup, positioned per breakpoint in SCSS).
 * Navigation is kept separate from the per-step actions, which live inline
 * within each step or page. Hidden entirely when there is only one destination,
 * since a single tab is pointless.
 */
export const BottomNav = () => {
  const { t } = useTranslation();
  const items = useNavItems();

  if (items.length < 2) return null;

  const linkClass = ({ isActive }: { isActive: boolean }) =>
    isActive ? "main-nav-link active" : "main-nav-link";

  return (
    <nav className="main-nav" aria-label={t("menu.label")}>
      <ul className="main-nav-list">
        {items.map((item) => (
          <li key={item.to} className="main-nav-item">
            <NavLink to={item.to} end={item.end} className={linkClass}>
              <span className="main-nav-icon" aria-hidden="true">
                {item.icon}
              </span>
              <span className="main-nav-label">{item.label}</span>
            </NavLink>
          </li>
        ))}
      </ul>
    </nav>
  );
};
